<template>
  <div class="flex flex-col h-full items-center justify-between gap-4 px-4 pb-8">
    <div class="flex flex-col items-center">
      <div class="rounded-full bg-[#4746C4] w-fit p-3 flex flex-row justify-center items-center">
        <img class="w-28 h-28" src="@/assets/icons/energy.svg" />
      </div>
      <div class="flex flex-col pt-6">
        <p class="text-lg font-semibold">Full Energy</p>
        <p class="text-xs text-GREY">0/3 daily</p>
      </div>
      <p class="text-sm font-normal pt-3">
        Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.
      </p>
    </div>

    <div class="flex flex-col gap-7 items-center w-full">
      <div class="flex flex-row gap-2 items-center">
        <p class="text-GREY text-sm">Profit per hour</p>
        <div class="flex flex-row items-center">
          <img class="w-5" src="@/assets/icons/token-2.svg" />
          <p class="font-semibold text-sm ps-1">0</p>
          <font-awesome-icon class="black-icon px-2" :icon="['fas', 'angles-right']" />

          <p class="font-semibold text-GREEN">150</p>
        </div>
      </div>
      <pow-button secondary class="w-full" :loading="loading">
        <p>Buy for Free</p>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import PowButton from '@/components/PowButton.vue'
import { ref } from 'vue'

const loading = ref(false)
</script>
